/* eslint-disable max-classes-per-file */
import { Component, Inject, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ICliente,
  TIPO_CONTRIBUINTE
} from '@app/modules/clientes/model/cliente.model';
import { ClienteService } from '@app/modules/clientes/services';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import { Utils } from '@app/shared/helpers/utils';
import { of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CustomValidators,
  Pattern,
  TokenService
} from 'viggo-sistemas-core-web';
import { SELECT } from '../../../../shared/components/search-header/components/search-header/search-header.component';
import { CpfCnpjPipe } from '../../../../shared/pipes/cpfCnpj-pipe/cpfCnpj.pipe';
import {
  validateCnpj,
  validateCpf
} from '../../../../shared/utils/validators_cpf_cnpj';
import { ClienteCpfCnpjAutorizados } from '../../../clientes/model/cliente.model';
import {
  FREQUENCIA_VISITAS,
  IClienteCarteiraVendedor,
  IVendedor
} from '../../../vendedor/model/vendedor.model';
import { VendedorService } from '../../../vendedor/services/vendedor-service/vendedor.service';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';

@Component({
  selector: 'fast-clients',
  templateUrl: './fast-clients.component.html',
  styleUrls: ['./fast-clients.component.scss'],
  providers: [ClienteService, VendedorService, ParceiroService, CpfCnpjPipe]
})
export class FastClientsComponent {
  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;
  contribuinteValue: string;

  contribuinteOptions: SELECT[] = [
    { viewValue: '1 - Contribuinte', value: 'CONTRIBUINTE' }
  ];

  isentoOptions: SELECT[] = [
    { viewValue: '9 - Não contribuinte', value: 'NAO_CONTRIBUINTE' },
    { viewValue: '2 - Isento', value: 'ISENTO' }
  ];

  messages = {
    nome_razao_social: {
      required: 'O nome é requerido.',
      maxlength: 'O nome deve ter no maximo 60 caracteres.',
      minlength: 'O nome é requerido.',
      isEmptyValue: 'Valor inválido: remova os espaços!'
    },
    apelido_nome_fantasia: {
      maxlength: 'Este nome é muito longo.',
      minlength: 'Este nome é muito curto.',
      isEmptyValue: 'Valor inválido: remova os espaços!'
    },
    cpf_cnpj: {
      repeated: 'Informação já cadastrada.',
      mask: 'Valor inválido.',
      required: 'O CPF/CNPJ é obrigatório',
      pattern: 'Este CPF/CNPJ é in#Sválido.',
      maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
      duplicate: 'O CPF/CNPJ já esta cadastrado',
      validateCPF: 'Este CPF é inválido.',
      validateCNPJ: 'Este CNPJ é inválido.'
    },
    cpf_cnpj_autorizado: {
      maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
      validateCPF: 'Este CPF é inválido.',
      validateCNPJ: 'Este CNPJ é inválido.'
    },
    rg_insc_est: {
      pattern: 'Este valor é inválido.',
      maxlength: 'O campo deve conter no máximo 20 caracteres.',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido: remova os espaços!'
    },
    insc_mun: {
      maxlength: 'O campo deve conter no máximo 15 caracteres.'
    },
    doc_estrangeiro: {
      maxlength: 'O campo deve conter no máximo 20 caracteres.'
    }
  };

  viewInit = false;

  insertDocEstrangeiro = false;
  findParceiro = false;

  vendedor = null;
  usa_fiscal = false;

  cpfCnpjMask = '000.000.000-00*';
  cpfCnpjMaskAtt = '000.000.000-00*';

  autorizados: ClienteCpfCnpjAutorizados[] = [];

  entity: ICliente = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as ICliente;

  constructor(
    public dialogRef: MatDialogRef<FastClientsComponent>,
    public clienteService: ClienteService,
    public tokenService: TokenService,
    private parceiroService: ParceiroService,
    private vendedorService: VendedorService,
    public snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    protected cpfCnpjPipe: CpfCnpjPipe,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      entity: ICliente;
      vendedor?: IVendedor;
      usa_fiscal?: boolean;
    }
  ) {}

  ngOnInit() {
    const { entity } = this.data;
    this.entity = entity;
    const today = new Date();
    if (this.data.vendedor) {
      this.vendedor = this.data.vendedor;
      delete this.vendedor.settings;
    }
    this.usa_fiscal = this.data.usa_fiscal;
    this.form = this.fb.group({});
    this.form = this.fb.group(
      this.usa_fiscal
        ? {
            nome_razao_social: [
              entity.parceiro.nome_razao_social,
              [
                Validators.required,
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            apelido_nome_fantasia: [
              entity.parceiro.apelido_nome_fantasia,
              [
                Validators.minLength(1),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            cpf_cnpj: [entity.parceiro.cpf_cnpj, [Validators.required]],
            rg_insc_est: [
              entity.parceiro.rg_insc_est,
              [
                Validators.pattern(Pattern.patternInscEstadual()),
                Validators.maxLength(20),
                CustomValidators.existSpecialChar(),
                CustomValidators.isEmptyValue()
              ]
            ],
            data_nascimento: [
              entity.data_nascimento,
              CustomValidators.date(today)
            ],
            cond_pagto: [
              entity.cond_pagto_favorita,
              [
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ],
            insc_mun: [entity.insc_mun, [Validators.maxLength(15)]],
            tipo_contribuinte: [
              entity.parceiro.rg_insc_est
                ? this.contribuinteOptions[0].value
                : entity.tipo_contribuinte
                ? this.isentoOptions.find(
                    op => op.value === entity.tipo_contribuinte
                  ).value
                : null
            ],
            doc_estrangeiro: [
              entity.parceiro.doc_estrangeiro
                ? entity.parceiro.doc_estrangeiro.trim()
                : '',
              [Validators.maxLength(20)]
            ],
            cpf_cnpj_autorizado: [null]
          }
        : {
            nome_razao_social: [
              entity.parceiro.nome_razao_social,
              [
                Validators.required,
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            apelido_nome_fantasia: [
              entity.parceiro.apelido_nome_fantasia,
              [
                Validators.minLength(1),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            cpf_cnpj: [entity.parceiro.cpf_cnpj, [Validators.required]],
            rg_insc_est: [
              entity.parceiro.rg_insc_est,
              [
                Validators.pattern(Pattern.patternInscEstadual()),
                Validators.maxLength(20),
                CustomValidators.existSpecialChar(),
                CustomValidators.isEmptyValue()
              ]
            ],
            data_nascimento: [
              entity.data_nascimento,
              CustomValidators.date(today)
            ],
            cond_pagto: [
              entity.cond_pagto_favorita,
              [
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ]
          }
    );

    if (entity.cpf_cnpj_autorizados && entity.cpf_cnpj_autorizados.length > 0) {
      entity.cpf_cnpj_autorizados.forEach(v => this.autorizados.push(v));
    }

    this.form.controls.cpf_cnpj.valueChanges.subscribe(value => {
      if (value) {
        if (this.usa_fiscal) this.form.controls.doc_estrangeiro.disable();
        this.validar(false);
        this.setMask(false);
      } else if (this.usa_fiscal && this.form.controls.doc_estrangeiro.disabled)
        this.form.controls.doc_estrangeiro.enable();
    });

    if (this.usa_fiscal) {
      const {
        rg_insc_est,
        tipo_contribuinte,
        doc_estrangeiro,
        cpf_cnpj_autorizado,
        cpf_cnpj
      } = this.form.controls;

      if (rg_insc_est.value) tipo_contribuinte.disable();

      rg_insc_est.valueChanges.subscribe(value => {
        if (value && rg_insc_est.valid) {
          tipo_contribuinte.setValue('CONTRIBUINTE');
          tipo_contribuinte.disable();
        } else {
          tipo_contribuinte.reset();
          tipo_contribuinte.enable();
        }
      });

      doc_estrangeiro.valueChanges.subscribe(value => {
        if (value) {
          this.insertDocEstrangeiro = true;
          cpf_cnpj.disable();
        } else if (cpf_cnpj.disabled) {
          this.insertDocEstrangeiro = false;
          cpf_cnpj.enable();
        }
      });

      cpf_cnpj_autorizado.valueChanges.subscribe(value => {
        if (value) {
          this.validar(true);
          this.setMask(true);
        }
      });
    }
  }

  validar(autorizados?: boolean) {
    if (autorizados) {
      let cpfCnpjValue = this.form.controls.cpf_cnpj_autorizado.value;
      if (cpfCnpjValue.toString().length <= 11) {
        if (validateCpf(cpfCnpjValue)) {
          this.form.controls.cpf_cnpj_autorizado.setErrors({
            validateCPF: true
          });
          this.form.updateValueAndValidity();
        }
      } else {
        if (validateCnpj(cpfCnpjValue)) {
          this.form.controls.cpf_cnpj_autorizado.setErrors({
            validateCNPJ: true
          });
          this.form.updateValueAndValidity();
        }
      }
    } else {
      let cpfCnpjValue = this.form.controls.cpf_cnpj.value;
      if (cpfCnpjValue.toString().length <= 11) {
        if (validateCpf(cpfCnpjValue)) {
          this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
          this.form.updateValueAndValidity();
        }
      } else {
        if (validateCnpj(cpfCnpjValue)) {
          this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
          this.form.updateValueAndValidity();
        }
      }
    }
  }

  setMask(autorizados?: boolean) {
    if (autorizados) {
      if (this.form.controls.cpf_cnpj_autorizado.value) {
        if (
          this.form.controls.cpf_cnpj_autorizado.value.toString().length <= 11
        )
          this.cpfCnpjMaskAtt = '000.000.000-00*';
        else {
          this.cpfCnpjMaskAtt = '00.000.000/0000-00';
        }
      }
    } else {
      if (this.form.controls.cpf_cnpj.value) {
        if (this.form.controls.cpf_cnpj.value.toString().length <= 11)
          this.cpfCnpjMask = '000.000.000-00*';
        else {
          this.cpfCnpjMask = '00.000.000/0000-00';
        }
      }
    }
  }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this.form.valid;
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.form.invalid) this.form.markAllAsTouched();
    return this.viewInit && this.form.invalid;
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;
    if (
      rgInsc.value === null ||
      rgInsc.invalid ||
      rgInsc.value === '' ||
      this.findParceiro
    )
      return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe((parceiro: IParceiro) => {
        if (parceiro[0] && parceiro[0].id) {
          this.form.controls.rg_insc_est.setErrors({ duplicate: true });
          this.form.updateValueAndValidity();
          return {} as IParceiro;
        }
      });
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (cpfCnpj.invalid) return;
    const cpfCnpjValue: string = cpfCnpj.value;

    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros => {
          if (parceiros.length) {
            this.findParceiro = true;
            return { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() };
          } else {
            this.findParceiro = false;
            return {} as IParceiro;
          }
        }),
        mergeMap(parceiro => {
          if (parceiro === undefined) return of(parceiro);
          return this.clienteService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return {} as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe((parceiro: IParceiro) => {
        if (parceiro === undefined) return;
        else if (Object.keys(parceiro).length !== 0) {
          this.setInformacoesParceiro(parceiro);
          this.form.patchValue({
            apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
            nome_razao_social: parceiro.nome_razao_social || null,
            rg_insc_est: parceiro.rg_insc_est || null,
            data_nascimento: null
          });
        }
      });
  }

  getValuesParceiro(): any {
    const {
      nome_razao_social,
      apelido_nome_fantasia,
      cpf_cnpj,
      rg_insc_est,
      doc_estrangeiro
    } = this.form.value as IParceiro;

    return Utils.trimAttributes({
      nome_razao_social,
      apelido_nome_fantasia,
      cpf_cnpj,
      rg_insc_est,
      doc_estrangeiro
    });
  }

  getValuesClient(): any {
    const { data_nascimento, insc_mun, tipo_contribuinte } = this.form
      .value as ICliente;

    return Utils.trimAttributes({
      data_nascimento,
      insc_mun,
      tipo_contribuinte: this.form.value.rg_insc_est
        ? ('CONTRIBUINTE' as TIPO_CONTRIBUINTE)
        : tipo_contribuinte,
      cpf_cnpj_autorizados: this.autorizados
    });
  }

  getCondPagto(): string {
    const { value } = this.form.get('cond_pagto');
    if (value === '' || value === null) {
      return null;
    }
    return value.id;
  }

  onSubmit(): void {
    var entity: ICliente = Utils.clearObject<ICliente>({
      ...this.entity,
      ...this.getValuesClient(),
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this.getValuesParceiro(),
        data_nascimento: undefined,
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      }),
      cond_pagto_favorita_id: this.getCondPagto(),
      data_nascimento: this.form.value.data_nascimento
    } as ICliente);

    entity.parceiro.pais_id = entity.parceiro.enderecos[0].pais_id ? entity.parceiro.enderecos[0].pais_id : null;
    delete entity.parceiro.enderecos[0].pais_id;

    if(this.insertDocEstrangeiro) entity.parceiro.enderecos = [];

    if (this.usa_fiscal && entity.parceiro.rg_insc_est)
      entity.tipo_contribuinte = 'CONTRIBUINTE' as TIPO_CONTRIBUINTE;
    delete entity.cond_pagto_favorita;
    delete entity.limite_credito;
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    if (entity.id) {
      this.update(entity);
    } else {
      this.insert(entity);
    }
  }

  insert(entity: ICliente): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.clienteService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, cliente]) => {
            return this.clienteService.getEntity(cliente.id, [
              'parceiro',
              'cond_pagto_favorita'
            ]);
          })
        )
        .subscribe(
          cliente => {
            this.snackBar.open('Cliente criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            if (this.vendedor) {
              this.vendedor.carteira.push({
                frequencia: FREQUENCIA_VISITAS.SEM_FREQUENCIA,
                cliente_id: cliente.id
              } as IClienteCarteiraVendedor);
              this.vendedorService
                .update({ ...this.vendedor, parceiro: undefined })
                .subscribe(v => {
                  this.dialogRef.close(cliente);
                });
            } else this.dialogRef.close(cliente);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.clienteService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(cliente => {
            return this.clienteService.getEntity(cliente.id, [
              'parceiro',
              'cond_pagto_favorita'
            ]);
          })
        )
        .subscribe(
          cliente => {
            this.snackBar.open('Cliente criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            if (this.vendedor) {
              this.vendedor.carteira.push({
                frequencia: FREQUENCIA_VISITAS.SEM_FREQUENCIA,
                cliente_id: cliente.id
              } as IClienteCarteiraVendedor);
              this.vendedorService
                .update({ ...this.vendedor, parceiro: undefined })
                .subscribe(v => {
                  this.dialogRef.close(cliente);
                });
            } else this.dialogRef.close(cliente);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  update(entity: ICliente): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.clienteService.update({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, cliente]) => {
            return this.clienteService.getEntity(cliente.id, [
              'parceiro',
              'cond_pagto_favorita'
            ]);
          })
        )
        .subscribe(
          cliente => {
            this.snackBar.open('Cliente atualizado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            // if (this.vendedor) {
            //   this.vendedor.carteira.push({
            //     frequencia: FREQUENCIA_VISITAS.SEM_FREQUENCIA,
            //     cliente_id: cliente.id
            //   } as IClienteCarteiraVendedor);
            //   this.vendedorService
            //     .update({ ...this.vendedor, parceiro: undefined })
            //     .subscribe(v => {
            //       this.dialogRef.close(cliente);
            //     });
            // } else
            this.dialogRef.close(cliente);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.clienteService.update({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(cliente => {
            return this.clienteService.getEntity(cliente.id, [
              'parceiro',
              'cond_pagto_favorita'
            ]);
          })
        )
        .subscribe(
          cliente => {
            this.snackBar.open('Cliente criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            // if (this.vendedor) {
            //   this.vendedor.carteira.push({
            //     frequencia: FREQUENCIA_VISITAS.SEM_FREQUENCIA,
            //     cliente_id: cliente.id
            //   } as IClienteCarteiraVendedor);
            //   this.vendedorService
            //     .update({ ...this.vendedor, parceiro: undefined })
            //     .subscribe(v => {
            //       this.dialogRef.close(cliente);
            //     });
            // } else
            this.dialogRef.close(cliente);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  enterPress() {
    if (this.form.controls.cpf_cnpj_autorizado.valid) {
      if (
        this.autorizados.find(v => v === this.form.value.cpf_cnpj_autorizado) ||
        this.autorizados.find(
          v => v.cpf_cnpj.trim() === this.form.value.cpf_cnpj_autorizado
        )
      )
        this.snackBar.open('Já está na lista de autorizados!', 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-error']
        });
      else {
        this.autorizados.push({
          cpf_cnpj: this.form.value.cpf_cnpj_autorizado
        } as any);
        this.form.controls.cpf_cnpj_autorizado.setValue('');
      }
    }
  }
}
